import { useSelector } from 'react-redux';

import ReturnLabelOption from 'components/account/Returns/ReturnLabelOption';
import ShippingForm from 'components/account/ShippingForm';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import WarningFilledSmallIcon from 'components/common/IconsV2/WarningFilledSmallIcon';
import { selectReturnItemCount } from 'selectors/returns';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/containers/returns/returnLabelOption.scss';

const MailLabelOption = ({
  shipping,
  labelDelivery,
  showMailedLabelOption,
  onUpdateShippingPhone,
  onCancelReturn,
  onUpdateMailingAddressOrName,
  onSubmitReturn,
  onReturnMethodSelect,
  isStoreCreditEnabled,
  labelPaymentType,
  zeroOriginalPaymentBalance,
  afterPayOrder
}) => {
  const returnItemCount = useSelector(selectReturnItemCount);
  if (!showMailedLabelOption) {
    return null;
  }

  const shippingForm = (
    <ShippingForm
      isReducedInfo={true}
      primaryVerbiage="Submit Return"
      shipping={shipping}
      isStoreCreditEnabled={isStoreCreditEnabled}
      labelPaymentType={labelPaymentType}
      zeroOriginalPaymentBalance={zeroOriginalPaymentBalance}
      afterPayOrder={afterPayOrder}
      onChangeShippingAddress={onSubmitReturn}
      onUpdateMailingAddressOrName={onUpdateMailingAddressOrName}
      onUpdateShippingPhone={onUpdateShippingPhone}
      onCancelClick={onCancelReturn}
      onResetShippingForm={f => f}
      className={css.shippingFormField}
    />
  );

  const checked = labelDelivery === PROVIDE_LABEL_OPTIONS.MAIL;

  const optionInformation = (
    <>
      <b className={css.optionInfo}>You will be receiving your label by USPS mail in 4-7 days at this address</b>
      {checked && returnItemCount > 1 && (
        <div className="my-2 flex gap-x-3">
          <div className="relative top-1 text-icon-warning-light">
            <WarningFilledSmallIcon size={16} />
          </div>
          <p>
            <span className="font-bold">This will only generate one label.</span> If you have multiple boxes, process a separate return for
            additional items and get a new label.
          </p>
        </div>
      )}
    </>
  );

  return (
    <>
      {labelDelivery !== PROVIDE_LABEL_OPTIONS.MAIL && (
        <button className="zappos:body-m-medium" type="button" onClick={onReturnMethodSelect} value={PROVIDE_LABEL_OPTIONS.MAIL}>
          Mail my label (takes 4-7 days)
        </button>
      )}
      {labelDelivery === PROVIDE_LABEL_OPTIONS.MAIL && (
        <ReturnLabelOption
          checked={labelDelivery === PROVIDE_LABEL_OPTIONS.MAIL}
          children={shippingForm}
          className={css.snail}
          id={PROVIDE_LABEL_OPTIONS.MAIL}
          optionTitle="Mail My Label"
          optionInformation={optionInformation}
          onReturnMethodSelect={onReturnMethodSelect}
          value={PROVIDE_LABEL_OPTIONS.MAIL}
        />
      )}
    </>
  );
};

export default MailLabelOption;
